<template>
  <div class="evaluation-list">
    <c-table
      ref="table"
      :columns="columns"
      url="/once/jhome"
      @after-fetch="afterFetch"
    >
      <el-table-column slot="name" label="任务名" :showOverflowTooltip="true" width="500">
        <template v-slot="{ row }">
          {{ row.taskname }}
        </template>
      </el-table-column>
      <el-table-column slot="uploader" label="上传者" :showOverflowTooltip="true" >
        <template v-slot="{ row }">
          {{ row.uploader }}
        </template>
      </el-table-column>
      <el-table-column slot="deliverto" label="分配给谁" :showOverflowTooltip="true" >
        <template v-slot="{ row }">
          {{ row.deliverto }}
        </template>
      </el-table-column>
      <el-table-column slot="time" label="时间" align="center">
        <template v-slot="{ row }">
          {{ row.time }}
        </template>
      </el-table-column>
      <el-table-column slot="action" label="操作" fixed="right" width="100">
        <template v-slot="{ row }">
          <el-button type="text" @click="goToDetail(row)">查看</el-button>
        </template>
      </el-table-column>
    </c-table>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import mixin from '@/mixins'
import permissionMixins from '@/mixins/permission'
export default {
  mixins: [mixin, permissionMixins],
  components: { CTable },
  data() {
    return {
      people: 0,
      columns: [{ slot: 'name' }, { slot: 'uploader' }, { slot: 'deliverto' }, { slot: 'time' }, { slot: 'action' }]
    }
  },
  computed: {

  },
  watch: {
    $route(to, from) {
      if (parseInt(to.query.active) === 1) {
        this.$refs.table.reload()
      }
    }
  },
  mounted() {

  },
  methods: {
    afterFetch(prize) {

    },
    goToDetail(row) {
      this.$router.push(`/mobile/detail/${row.fileid}`)
    }
  }
}
</script>

<style lang="scss">
.evaluation-list {
  .overflow {
    width: 570px;
    text-overflow: ellipsis;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    &.name {
      width: 170px;
    }
  }
}
</style>
